'use client'

import Image from 'next/image'

import { LocalizedLink } from '@src/components/LocalizedLink/LocalizedLink'
import type { TopNavTile as TopNavTileType } from '@src/components/TopNavV3/TopNavProps'
import { useTrackSelectNavCta } from '@src/utils/analytics.util'

export const TopNavTile = (props: { tile?: TopNavTileType }) => {
  const { tile } = props
  const trackSelectNavCta = useTrackSelectNavCta()

  return (
    <LocalizedLink
      rel={tile?.newTab ? 'noopener noreferrer' : ''}
      target={tile?.newTab ? '_blank' : '_self'}
      href={tile?.href ?? ''}
      className="w-full font-medium"
      onClick={() => {
        trackSelectNavCta({ 'cta url': tile?.href })
      }}
    >
      <div className="relative mb-2 aspect-3/2 w-full overflow-hidden rounded-[30px] bg-bodi-gray-medium">
        <Image className=" object-cover" src={tile?.image ?? ''} alt={tile?.alt ?? ''} fill />
      </div>
      {tile?.stamp && <div className="w-fit text-bodi-green-bright-500">{tile.stamp}</div>}
      <div className="w-fit text-white">{tile?.title}</div>
    </LocalizedLink>
  )
}
